export * from './ComparisonRegisterStep2';
